export default __webpack_public_path__ + "static/media/Icon_Gallery_Blue.d7e9b8da.png";